import React, { ReactElement } from "react";
import { Worker, Viewer, ProgressBar } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin, ToolbarProps, ToolbarSlot } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Box, Button, HStack } from "@chakra-ui/react";
import { isDesktopHook } from "../../Hooks";
import { Hide } from "../common/Hide";

export interface ToolbarItem {
  label: string;
  onClick: () => void;
}

interface Props {
  fileUrl: string;
  toolbarItems?: ToolbarItem[];
}

export function ReadPdf({ fileUrl, toolbarItems }: Props): ReactElement {
  const toolbarButtons = toolbarItems?.map((tool) => (
    <Button color="black" h="100%" onClick={tool.onClick} key={tool.label}>
      {tool.label}
    </Button>
  ));
  const isDesktop = isDesktopHook();

  const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
    <Toolbar>
      {(slots: ToolbarSlot) => {
        const { ZoomIn, Zoom, ZoomOut, Print, GoToPreviousPage } = slots;
        return (
          <div
            style={{
              alignItems: "center",
              display: "flex",
            }}
          >
            <Hide hide={!isDesktop}>
              <HStack ml={"45vw"} spacing={"1vw"}>
                <ZoomOut />
                <Zoom />
                <ZoomIn />
              </HStack>
            </Hide>
            <HStack ml={isDesktop ? "5vw" : "2vw"} spacing={isDesktop ? "5vw" : "2vw"}>
              {toolbarButtons}
              <Print>
                {(props) => (
                  <Button onClick={props.onClick} color="black" h="100%">
                    Print
                  </Button>
                )}
              </Print>
            </HStack>
          </div>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: (tabs) => [],
  });

  // Render

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <Viewer
        fileUrl={fileUrl}
        plugins={[defaultLayoutPluginInstance]}
        defaultScale={isDesktop ? 1 : 0.5}
        renderLoader={(percentages: number) => (
          <Box width="30vw" marginTop="40vh">
            <ProgressBar progress={Math.round(percentages)} />
          </Box>
        )}
      />
    </Worker>
  );
}
